////////////////////////////////////////////////////////////
//     							                          //
//  Program: ApiService.js                                //
//  Application: Services                                 //
//  Option: Used to call all external/third party apis    //
//  Developer: Jay Jani  						                  //
//  Date: 25-05-2022                                  //
//                                                        //
////////////////////////////////////////////////////////////

import axios from "axios";

// const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT;
const CMS_BASE_URL = process.env.REACT_APP_CMS_ENDPOINT;
const WEBVIEW_BASE_URL = process.env.REACT_APP_WEBVIEW_ENDPOINT;
const HEADER_TOKEN = localStorage.getItem("headerToken")
  ? localStorage.getItem("headerToken")
  : "";
// const BASE_PATH = process.env.REACT_APP_BASE_PATH ? process.env.REACT_APP_BASE_PATH : ""
// const GEOLOCATION_IP_URL = process.env.REACT_APP_GEOLOCATION_IP_URL;

const DEVICE_TYPE = process.env.REACT_APP_DEVICE_TYPE;
const ROLE = global.currerntRoleSlug
  ? global.currerntRoleSlug
  : localStorage.getItem("currerntRoleSlug")
  ? localStorage.getItem("currerntRoleSlug")
  : "";
const HEADER_X_TOKEN = process.env.REACT_APP_X_AUTH_TOKEN;
const PLATEFORM_KEY =
  localStorage.getItem("platFormKey") || process.env.REACT_APP_PLATEFORM_KEY;

class CmsService {
  async getCMSCall(inputData) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + HEADER_TOKEN,
        "X-Authorization": HEADER_X_TOKEN,
        "device-type": DEVICE_TYPE,
        "platform-key": PLATEFORM_KEY,
        role: ROLE,
        // 'ipData': JSON.stringify(ipData)
      },
    };

    // Merdge addition header data from request call
    if (Object.keys(inputData.addditionalHeaderData).length > 0) {
      axiosConfig = {
        ...axiosConfig.headers,
        ...inputData.addditionalHeaderData,
      };
    }

    return axios
      .get(CMS_BASE_URL + inputData.endPoint, axiosConfig)
      .then((res) => {
        return {
          status: res.status,
          message: res.data.message,
          data: res.data.result,
        };
      })
      .catch((err) => {
        if (err.response.status === 401 || err.response.status === 429) {
          return (window.location.href = "/logout");
        } else {
          return {
            status: err["response"] !== undefined ? err.response.status : 503,
            message:
              err["message"] !== undefined
                ? err.message
                : "Service Unavailable",
            data: err.response.data ? err.response.data : {},
          };
        }
      });
  }

  async postCMSCall(inputData) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + HEADER_TOKEN,
        "X-Authorization": HEADER_X_TOKEN,
        "device-type": DEVICE_TYPE,
        "platform-key": PLATEFORM_KEY,
        role: ROLE,
        // 'ipData': JSON.stringify(ipData)
      },
    };

    // Merdge addition header data from request call
    if (Object.keys(inputData.addditionalHeaderData).length > 0) {
      axiosConfig = {
        ...axiosConfig.headers,
        ...inputData.addditionalHeaderData,
      };
    }

    return axios
      .post(CMS_BASE_URL + inputData.endPoint, inputData.postData, axiosConfig)
      .then((res) => {
        return {
          status: res.status,
          message: res.data.message,
          data: res.data.result,
          other_data: res.data.other_data,
        };
      })
      .catch((err) => {
        if (err.response.status === 401 || err.response.status === 429) {
          return (window.location.href = "/logout");
        } else {
          return {
            status: err["response"] !== undefined ? err.response.status : 503,
            message:
              err["message"] !== undefined
                ? err.message
                : "Service Unavailable",
            data: err.response.data ? err.response.data : {},
            other_data: err.response.data.other_data
              ? err.response.data.other_data
              : {},
          };
        }
      });
  }

  async putCMSCall(inputData) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + HEADER_TOKEN,
        "X-Authorization": HEADER_X_TOKEN,
        "device-type": DEVICE_TYPE,
        "platform-key": PLATEFORM_KEY,
        role: ROLE,
      },
    };

    // Merdge addition header data from request call
    if (Object.keys(inputData.addditionalHeaderData).length > 0) {
      axiosConfig = {
        ...axiosConfig.headers,
        ...inputData.addditionalHeaderData,
      };
    }

    return axios
      .put(CMS_BASE_URL + inputData.endPoint, inputData.postData, axiosConfig)
      .then((res) => {
        return {
          status: res.status,
          message: res.data.message,
          data: res.data.result,
        };
      })
      .catch((err) => {
        if (err.response.status === 401 || err.response.status === 429) {
          return (window.location.href = "/logout");
        } else {
          return {
            status: err["response"] !== undefined ? err.response.status : 503,
            message:
              err["message"] !== undefined
                ? err.message
                : "Service Unavailable",
            data: err.response.data ? err.response.data : {},
          };
        }
      });
  }

  async deleteCMSCall(inputData) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + HEADER_TOKEN,
        "X-Authorization": HEADER_X_TOKEN,
        "device-type": DEVICE_TYPE,
        "platform-key": PLATEFORM_KEY,
        role: ROLE,
      },
    };

    // Merdge addition header data from request call
    if (Object.keys(inputData.addditionalHeaderData).length > 0) {
      axiosConfig = {
        ...axiosConfig.headers,
        ...inputData.addditionalHeaderData,
      };
    }

    return axios
      .delete(CMS_BASE_URL + inputData.endPoint, axiosConfig)
      .then((res) => {
        return {
          status: res.status,
          message: res.data.message,
          data: res.data.result,
        };
      })
      .catch((err) => {
        if (err.response.status === 401 || err.response.status === 429) {
          return (window.location.href = "/logout");
        } else {
          return {
            status: err["response"] !== undefined ? err.response.status : 503,
            message:
              err["message"] !== undefined
                ? err.message
                : "Service Unavailable",
            data: err.response.data ? err.response.data : {},
          };
        }
      });
  }

  async uploadCMSFileCall(inputData) {
    let axiosConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + HEADER_TOKEN,
        "X-Authorization": HEADER_X_TOKEN,
        "device-type": DEVICE_TYPE,
        "platform-key": PLATEFORM_KEY,
        role: ROLE,
      },
    };

    // Merdge addition header data from request call
    if (Object.keys(inputData.addditionalHeaderData).length > 0) {
      axiosConfig = {
        ...axiosConfig.headers,
        ...inputData.addditionalHeaderData,
      };
    }

    return axios
      .post(CMS_BASE_URL + inputData.endPoint, inputData.postData, axiosConfig)
      .then((res) => {
        return {
          status: res.status,
          message: res.data.message,
          data: res.data.result,
        };
      })
      .catch((err) => {
        if (err.response.status === 401 || err.response.status === 429) {
          return (window.location.href = "/logout");
        } else {
          return {
            status: err["response"] !== undefined ? err.response.status : 503,
            message:
              err["message"] !== undefined
                ? err.message
                : "Service Unavailable",
            data: err.response.data ? err.response.data : {},
          };
        }
      });
  }

  async getMobileCall(header, inputData) {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + (sessionStorage.getItem("headerToken") || header.authToken || ""),
        "platform-key": sessionStorage.getItem("platFormKey") || header.platformKey || "",
      },
    };

    return axios
      .get(WEBVIEW_BASE_URL + inputData.endPoint, axiosConfig)
      .then((res) => {
        return {
          status: res.status,
          message: res.data.message,
          data: res.data.result,
          other_data: res.data.other_data,
        };
      })
      .catch((err) => {
        if (err.response?.status === 401 || err.response?.status === 429) {
          // Handle unauthorized or too many requests
          return { status: err.response.status, message: "Unauthorized" };
        } else {
          return {
            status: err.response?.status || 503,
            message: err.message || "Service Unavailable",
            data: err.response?.data || {},
          };
        }
      });
  }
}

export default new CmsService();
